// angular
import { SlicePipe } from '@angular/common';
import { Component, ElementRef, input, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// components
import { TooltipComponent } from '../tooltip/tooltip.component';

@Component({
  selector: 'pwj-text-summarizer',
  standalone: true,
  imports: [SlicePipe, TooltipComponent, TranslateModule],
  templateUrl: './text-summarizer.component.html',
  styleUrl: './text-summarizer.component.scss',
})
export class TextSummarizerComponent {
  public showsTooltip = false;
  public topPosition!: number | null;
  public leftPosition!: number | null;
  public tooltipText: string = '';

  // inputs
  text = input<string | null>();
  limitLength = input<number>(20);
  truncate = input<boolean>(false);
  justTooltip = input<boolean>(false);

  @ViewChild('textContainer', { static: true })
  textContainer!: ElementRef<HTMLElement>;

  constructor() {}

  public onHover() {
    if (this.truncate()) {
      const el = this.textContainer?.nativeElement;
      if (el && el.scrollWidth > el.clientWidth) {
        setTimeout(() => {
          this.showsTooltip = true;
        }, 500);
        this.tooltipText = this.text() as string;
      }
      return;
    }

    if (this.text() && (this.text()?.length as number) > this.limitLength()) {
      setTimeout(() => {
        this.showsTooltip = true;
      }, 500);
      this.tooltipText = this.text() as string;
    }
  }
  public onMouseout() {
    this.showsTooltip = false;
    this.tooltipText = '';
    this.topPosition = null;
    this.leftPosition = null;
  }

  public onMouseMove(e: MouseEvent) {
    if (this.truncate()) {
      const el = this.textContainer?.nativeElement;
      if (el && el.scrollWidth > el.clientWidth) {
        const targetRect = el.getBoundingClientRect();
        this.topPosition = e.clientY - targetRect.top + 25;
        this.leftPosition = e.clientX - targetRect.left - 20;
      }
      return;
    }

    if (this.text() && (this.text()?.length as number) > this.limitLength()) {
      const targetRect =
        this.textContainer?.nativeElement.getBoundingClientRect();

      // Calculate new position
      this.topPosition = e.clientY - targetRect?.top + 25;
      this.leftPosition = e.clientX - targetRect?.left - 20;
    }
  }
}
